import axios from 'lib/axios';

const getAllDivisions = async (query = '') => {
  const { data } = await axios.get(`/customer/division?query=${query}`);
  return data;
};

const getDivisionById = async (id) => {
  const { data } = await axios.get(`/customer/division/${id}`);
  return data;
};

export { getAllDivisions, getDivisionById };
